import API from '../..';
const ENTITY = 'phone';

export const getPhoneCodes = () => API.get(`/api/v1/${ENTITY}-codes/`);
